module.exports = __webpack_public_path__ + "img/Job_d_banner.37f87952.png";